<div class="super-container">
  <div class="container">
    <h6 i18n>Your profile</h6>
    <form>
      <div class="inputs">
        <app-input
          [formCntlName]="name"
          [inputType]="textInputType"
          [label]="nameLabel"
          (callbackInputEvent)="handleCallback($event)"
        ></app-input>
        <app-input
          [formCntlName]="email"
          [inputType]="emailInputType"
          [label]="emailLabel"
          [prefixInputIcon]="mailIcon"
          (callbackInputEvent)="handleCallback($event)"
        ></app-input>
        <app-input
          [formCntlName]="phone"
          [inputType]="textInputType"
          [label]="phnLabel"
          [inputStyle]="phnStyle"
          [prefixInputIcon]="phoneIcon"
          (callbackInputEvent)="handleCallback($event)"
        ></app-input>
        <app-input
          [formCntlName]="orgName"
          [inputType]="textInputType"
          [label]="orgnameLabel"
          [prefixInputIcon]="accountCircleIcon"
          (callbackInputEvent)="handleCallback($event)"
        ></app-input>
      </div>
    </form>
    <app-notification-settings></app-notification-settings>
  </div>
</div>
